module.exports = __webpack_public_path__ + "static/13b34e3a2dde3c17c6365d07a99e9483f07c263fe066a1be2d987e63a8731968-ab53172775ee2b20259619808916829f.png";